/*
 * @Author: Veto [关于音缘部分 路由]
 * @Date: 2023-12-26 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-01-16 18:47:10
 */

import Privacy from '../views/yinyuan/privacy';
import User from '../views/yinyuan/user';
import LegalMale from '../views/yinyuan/legal_male';
import LegalFemale from '../views/yinyuan/legal_female';
import Pay from '../views/yinyuan/pay';
import Share from '../views/yinyuan/share';

import Help from '../views/warning/faq_tianmi';
import Vip from '../views/yinyuan/vip';


const router = {
    '/yinyuan-privacy': Privacy,
    '/yinyuan-user': User,
    '/yinyuan-help': Help,
    '/yinyuan-legal-male': LegalMale,
    '/yinyuan-legal-female': LegalFemale,
    '/yinyuan-pay': Pay,
    '/yinyuan-share': Share,

    '/yinyuan-vip': Vip
};


export default router;